"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var helpers_1 = require("../helpers");
var translate = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        left: 0;\n        right: 99%;\n        transform: translateX(0)\n    }\n\n    50% {\n        left: 0;\n        right: 25%;\n    }\n\n    100% {\n        left: 99%;\n        right: 0;\n        transform: translateX(25%)\n    }\n"], ["\n    0% {\n        left: 0;\n        right: 99%;\n        transform: translateX(0)\n    }\n\n    50% {\n        left: 0;\n        right: 25%;\n    }\n\n    100% {\n        left: 99%;\n        right: 0;\n        transform: translateX(25%)\n    }\n"])));
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: ", ";\n    position: relative;\n    overflow: hidden;\n\n    &:before {\n        content: '';\n\n        position: absolute;\n        left: 0;\n        right: 0;\n\n        top: 0;\n        bottom: 0;\n        background-color: ", ";\n\n        animation: ", " 1s ease-out infinite;\n    }\n"], ["\n    height: ", ";\n    position: relative;\n    overflow: hidden;\n\n    &:before {\n        content: '';\n\n        position: absolute;\n        left: 0;\n        right: 0;\n\n        top: 0;\n        bottom: 0;\n        background-color: ", ";\n\n        animation: ", " 1s ease-out infinite;\n    }\n"])), helpers_1.SIZE_XXS, function (_a) {
    var theme = _a.theme;
    return theme.colorProgressIndicator;
}, translate);
exports.ProgressBar = helpers_1.createUIElement('ProgressBar', function (_a, ref) {
    var className = _a.className, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, style = _a.style, rest = __rest(_a, ["className", "onMouseEnter", "onMouseLeave", "style"]);
    return (react_1.default.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'progress-bar', className: "vm-ProgressBar " + className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: ref, style: style })));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=ProgressBar.js.map